<template>
  <v-text-field
    v-bind="effectiveBindings"
    class="sn-text-field"
    v-on="$listeners"
  />
</template>

<script>
import vuetifyOverrideMixin from '~/components/snui/v2/mixins/vuetifyOverrideMixin.vue'

export default {
  name: 'SnTextField',
  mixins: [vuetifyOverrideMixin],
  data () {
    return {
      vuetifyOverrideMixin: {
        defaultProps: {
          hideDetails: 'auto'
        },
        overriddenProps: {
          appendIcon: undefined,
          appendOuterIcon: undefined,
          backgroundColor: undefined,
          clearIcon: '$snExit',
          color: undefined,
          counter: undefined,
          counterValue: null,
          dark: false,
          dense: false,
          errorCount: 1,
          filled: false,
          flat: false,
          fullWidth: false,
          height: undefined,
          hideSpinButtons: false,
          label: undefined,
          light: false,
          loaderHeight: 2,
          loading: false,
          messages: [],
          outlined: false,
          persistentHint: true,
          persistentPlaceholder: false,
          prependIcon: undefined,
          prependInnerIcon: undefined,
          reverse: false,
          rounded: false,
          shaped: false,
          singleLine: false,
          solo: false,
          soloInverted: false,
          success: false,
          successMessages: [],
          suffix: undefined
        }
      }
    }
  },
  computed: {
    effectiveBindings () {
      var bindings = {
        ...this.vuetifyOverrideMixin.bindings
      }

      if (bindings.id) {
      // Use the field's ID to generate a data-cy value for convenience purposes
        bindings['data-cy'] = `${bindings.id}-field`
      }
      return bindings
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~/components/snui/v2/mixins/vuetifyOverrideCss.scss';

.sn-text-field {
  @extend .v-text-field--sn_override;
}

</style>
